import API from './API';
import { GET } from '../utils/Executer';
import { DOCUMENT_EDITOR_SERVICE_URL as servicePath } from '../constants/APIconstants';

class DocumentEditorServiceAPI {
  /**
   * Get Document Editor configuration for a knowledge item
   * @param {string} itemId - The knowledge item ID
   * @param {'view' | 'edit'} mode - 'view' for read-only, 'edit' for editing
   * @returns {Promise<{ success: boolean, code: number, data: { config: object, documentServerUrl: string } }>}
   */
  async getEditorConfig(itemId, mode = 'view') {
    return await API.client.execute(GET, `${servicePath}config/${itemId}?mode=${mode}`);
  }

  /**
   * Get a Document Editor configuration for an uploaded asset
   * that is not yet attached to a knowledge item (post-upload, pre-save)
   * @param {string} fileName - The asset file name (without extension)
   * @param {'view' | 'edit'} mode - 'view' for read-only, 'edit' for editing
   * @returns {Promise<{ success: boolean, code: number, data: { config: object, documentServerUrl: string } }>}
   */
  async getAssetEditorConfig(fileName, mode = 'view') {
    // A failed config fetch must not cascade into token refresh + logout -
    // the editor falls back to the download view instead
    return await API.assetsClient.execute(
      GET,
      `/assets/${fileName}/editor-config?mode=${mode}`,
      {},
      { skipGenericErrorHandling: true },
    );
  }
}

export default new DocumentEditorServiceAPI();
